import type { ApolloError } from 'apollo-client';
import type { GraphQLError } from 'graphql';

export const isExpectedApolloError = (error: ApolloError | undefined): boolean => {
	if (error) {
		return error.graphQLErrors?.every(isExpectedGraphqlError);
	}
	return false;
};

const isExpectedGraphqlError = (error: GraphQLError) => {
	return (
		isFeedConfigSpacePermissionError(error) ||
		isFeedConfigUserPermissionError(error) ||
		isFeedConfigDeletedSpaceError(error)
	);
};

const feedConfigSpacesPath = ['getFeedUserConfig', 'spaces'];

// Deleted space id error when the user is following a deleted space
export const isFeedConfigDeletedSpaceError = (error: GraphQLError) => {
	return (
		feedConfigSpacesPath.every((path) => error.path?.includes(path)) &&
		error.message?.includes('Cannot find space with id:')
	);
};

// Permission check error when the user is following a restricted space
export const isFeedConfigSpacePermissionError = (error: GraphQLError) => {
	return (
		feedConfigSpacesPath.every((path) => error.path?.includes(path)) &&
		error.message?.includes('Not permitted to view space with id:')
	);
};

const feedConfigUsersPath = ['getFeedUserConfig', 'users'];
export const isFeedConfigUserPermissionError = (error: GraphQLError) => {
	return (
		feedConfigUsersPath.every((path) => error.path?.includes(path)) &&
		error.message?.includes('User not permitted to access Confluence')
	);
};
